export * from './src/loyalty-socialmedia-v1-followed-channel-social-media.meta.js';
